<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header px-4">
      <h3 class="modal-title" id="exampleModalCenterTitle">Please confirm...</h3>
    </div>

    <div class="modal-body px-4">
      <h5>Do you really want to cancel this
        order?</h5>
    </div>

    <div class="modal-footer px-4">
      <button type="button" class="btn btn-secondary btn-pill" data-bs-dismiss="modal">No</button>
      <button type="button" class="btn btn-primary btn-pill" (click)="deleteItem()" data-bs-dismiss="modal">Confirm</button>
    </div>
  </div>
</div>